var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCallIcon = function SvgCallIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.404.03c.476.098.853.417 1.088.838L5.24 2.21c.276.494.507.91.658 1.271.16.384.256.762.213 1.18s-.215.768-.451 1.11c-.223.323-.536.682-.907 1.108l-.97.958c1.479 2.424 3.732 4.9 6.159 6.38l1.178-.97c.428-.37.786-.684 1.108-.907.342-.236.693-.407 1.111-.45.419-.045.795.051 1.18.212.361.15.777.383 1.27.659l1.342.747c.422.235.74.613.838 1.087.1.48-.046.96-.369 1.357-1.172 1.437-3.048 2.352-5.016 1.955-1.21-.244-2.404-.65-3.848-1.479-2.902-1.663-5.503-4.266-7.164-7.163C.744 7.82.337 6.627.093 5.417-.304 3.447.61 1.572 2.048.4c.396-.322.877-.468 1.356-.37",
    clipRule: "evenodd"
  })));
};
export default SvgCallIcon;